"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserSchema = exports.UserFields = exports.UserMetadataSchema = exports.NotificationSettingsFields = exports.NotificationMessageFields = exports.InvitationSchema = exports.InvitationFields = exports.TeamSchema = exports.TeamFields = exports.TierSchema = exports.TierFields = exports.TierFeaturesSchema = exports.CampaignSchema = exports.CampaignFields = void 0;
const typebox_1 = require("@sinclair/typebox");
const core_1 = require("../../core");
const ruby_1 = require("../../ruby");
/**
 * Campaigns
 */
exports.CampaignFields = {
    name: core_1.NameSchema,
    description: core_1.DescriptionSchema,
    status: ruby_1.CampaignStatusSchema,
    channelType: ruby_1.ChannelTypeSchema,
    objective: typebox_1.Type.Optional(ruby_1.ObjectiveSchema),
};
exports.CampaignSchema = (0, core_1.StrictObject)({
    ...core_1.ModelMetaFields,
    ...exports.CampaignFields,
});
/**
 * Tiers
 */
// TODO: Ideally this would have both known and unknown options, but
exports.TierFeaturesSchema = (0, core_1.JSONObject)({}, {
    title: "Tier Features",
    description: "Configuration of tier",
});
exports.TierFields = {
    name: core_1.NameSchema,
    description: core_1.DescriptionSchema,
    maxDailySpend: typebox_1.Type.Optional(core_1.MoneySchema),
    payment: ruby_1.PaymentModelSchema,
    fee: ruby_1.TierFeeSchema,
    hosted: typebox_1.Type.Boolean(),
    private: typebox_1.Type.Boolean(),
    status: ruby_1.TierStatusSchema,
    features: exports.TierFeaturesSchema,
};
exports.TierSchema = (0, core_1.StrictObject)({
    ...core_1.ModelMetaFields,
    ...exports.TierFields,
});
/**
 * Teams
 */
exports.TeamFields = {
    name: core_1.NameSchema,
    description: core_1.DescriptionSchema,
    // Ideally a team should have a tier, but there's a chance the Tier is deleted
    // so we need to allow null here.
    // We should not allow this to happen to maintain database/application integrity
    // but they are separate objects.
    tier: typebox_1.Type.Optional(exports.TierSchema),
    status: ruby_1.TeamStatusSchema,
    currency: core_1.CurrencySchema,
    isAgencyAccount: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
    clientType: ruby_1.ClientTypeSchema,
};
exports.TeamSchema = (0, core_1.StrictObject)({
    ...core_1.ModelMetaFields,
    ...exports.TeamFields,
});
/**
 * Invitations
 */
exports.InvitationFields = {
    userId: typebox_1.Type.Optional(core_1.IdSchema),
    email: typebox_1.Type.Optional(core_1.EmailSchema),
    role: ruby_1.TeamRoleSchema,
    teamId: core_1.IdSchema,
    teamName: core_1.NameSchema,
};
exports.InvitationSchema = (0, core_1.StrictObject)({
    ...core_1.ModelMetaFields,
    ...exports.InvitationFields,
});
/**
 * Notification Settings
 */
exports.NotificationMessageFields = {
    ...core_1.ModelMetaFields,
    timestamp: core_1.TimestampSchema,
    type: ruby_1.NotificationTypeSchema,
    payload: typebox_1.Type.Unknown(),
};
exports.NotificationSettingsFields = {
    email: typebox_1.Type.Array(ruby_1.NotificationTypeSchema),
    web: typebox_1.Type.Array(ruby_1.NotificationTypeSchema),
};
/**
 * Users
 */
exports.UserMetadataSchema = (0, core_1.JSONObject)({}, {
    title: "Metadata",
    description: "Additional metadata for user",
});
exports.UserFields = {
    name: core_1.NameSchema,
    // This may be optional as we only take email which are verified
    email: typebox_1.Type.Optional(core_1.EmailSchema),
    role: ruby_1.UserRoleSchema,
    status: ruby_1.UserStatusSchema,
};
exports.UserSchema = (0, core_1.StrictObject)({
    ...core_1.ModelMetaFields,
    ...exports.UserFields,
});
